<di-navbar #navbar="vudNavbar">
  <di-navbar-brand data-testid="visma-menu" role="menu">
    <div class="tw:inline-flex tw:justify-between tw:items-center">
      <span class="tw:inline-flex payroll-icon tw:items-center"></span>
      <span>Payroll</span>
    </div>
  </di-navbar-brand>
  @for (menuItem of menuItems$ | async; track menuItem) {
    <di-navbar-brand-option
      [href]="
        menuItem.url +
        '/' +
        (menuItem.webApplicationUri ?? '') +
        '/?switchApplicationModule=' +
        environment.empManModuleId +
        '&contextSelector:switchContext=' +
        (userCompany$ | async).id +
        '&orgId=' +
        (userCompany$ | async).id
      "
      [label]="menuItem.name"
    />
  }
  <di-navbar-brand-option label="Payroll" [active]="true" />
  <di-navbar-menu>
    <di-navbar-menu-item
      class="virtual"
      label="Payroll"
      [href]="environment.vismaAboutUrl + (userCompany$ | async).id"
      i18n-label
    />
    <di-navbar-menu-item label="Employees" routerLink="/employees" routerLinkActive i18n-label>
      <di-navbar-secondary-menu>
        <di-navbar-menu-item label="Employee list" routerLink="/employees" routerLinkActive i18n-label />
        <di-navbar-menu-item
          label="Employee card"
          routerLink="/employee"
          routerLinkActive
          [isDisabled]="isEmployeeCardDisabled$ | async"
          [tooltipText]="functionDisabledTooltip"
          i18n-label
        />
        <di-navbar-menu-item label="History" routerLink="/history" routerLinkActive i18n-label />
        <di-navbar-menu-item
          label="Import vacation balances"
          routerLink="calendar/vacation-balance-import"
          routerLinkActive
          [isDisabled]="disabledOperationsSignal()[OperationTypeEnum.VacationBalanceImport]"
          [tooltipText]="functionDisabledTooltip"
          i18n-label
        />
        <di-navbar-menu-item
          label="Import absences"
          routerLink="calendar/absence-import"
          routerLinkActive
          [isDisabled]="disabledOperationsSignal()[OperationTypeEnum.AbsenceRegistrationImport]"
          [tooltipText]="functionDisabledTooltip"
          i18n-label
        />

        <di-navbar-menu-item
          label="Go to previous version of Employees"
          [isExternalLink]="true"
          (click)="openLegacyEM()"
          i18n-label
        />
      </di-navbar-secondary-menu>
    </di-navbar-menu-item>
    <di-navbar-menu-item
      label="Payroll portal"
      routerLink="/payroll-portal"
      routerLinkActive
      *diIsFeatureDisabled="'disable-payroll-portal-tab'"
      i18n-label
    />
    <di-navbar-menu-item
      label="Reports"
      [href]="environment.vismaAboutUrl + (userCompany$ | async).id + '/reports'"
      i18n-label
    />
    <di-navbar-menu-item label="Settings" routerLink="/settings" routerLinkActive i18n-label />
  </di-navbar-menu>
  <di-navbar-right-menu>
    @if (user$ | async; as user) {
      <li class="icon" id="walkme-launcher" *diIsFeatureDisabled="'disable-walkme'">
        <a (click)="openWalkme()">
          <ga-icon color="white" [icon]="icons.CircleQuestionMark" />
        </a>
      </li>
      <li class="icon">
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLScM0v7zEve0kS3juyegAhi_gik_CMetBbsTDPui6TGQeZXwZQ/viewform"
          aria-label="Send us feedback"
          rel="noopener noreferrer"
          target="_blank"
        >
          <span class="vismaicon vismaicon-menu vismaicon-feedback" data-testid="feedback-icon"></span>
        </a>
      </li>
      <li class="icon" *diIsFeatureDisabled="'disable-ai-assistant'">
        <a
          data-test="vsn-assistant-button"
          title="VSN Assistant"
          role="button"
          aria-label="VSN Assistant"
          #gaiaAssistantButton
          (click)="openAssistant()"
          i18n-aria-label
          i18n-title
        >
          <ga-icon size="24px" [icon]="icons.Sparkles" />
        </a>
      </li>
      @if (userCompany$ | async; as userCompany) {
        <li
          class="dropdown user-dropdown"
          diVudDropdown
          #dropdown="diVudDropdown"
          [class.icon]="navbar.isTablet$ | async"
          [class.open]="dropdown.isOpen$ | async"
        >
          <a
            class="dropdown-toggle"
            data-testid="user-menu"
            role="menu"
            diVudDropdownToggle
            [class.tw:max-w-75]="(navbar.isTablet$ | async) === false"
            [class.tw:min-w-75]="(navbar.isTablet$ | async) === false"
          >
            {{ user.firstName }} {{ user.lastName }}
            @if ((navbar.isTablet$ | async) === true) {
              <ga-icon color="white" [icon]="icons.User" />
            }
            <small title="{{ userCompany.name }}">{{ userCompany.name }}</small>
            <span class="caret tw:right-6"></span>
          </a>
          <ul class="dropdown-menu company-selection" data-testid="company-selection-menu" diVudDropdownMenu>
            @if (user.availableContexts?.length > 1) {
              <li class="tw:overflow-visible">
                <label id="companySwitchSelectLabel" i18n>Switch company</label>
                <div class="tw:px-4">
                  <ga-data-select
                    class="tw:w-full"
                    aria-labelledby="companySwitchSelectLabel"
                    bindLabel="name"
                    searchable
                    [compareFn]="compareCompanies"
                    [items]="user.availableContexts"
                    [value]="userCompany"
                    (valueChange)="selectCompany($event)"
                  />
                </div>
              </li>
              <li class="divider"></li>
            }
            <li class="user-details-area tw:cursor-default">
              <div [title]="user.emailAddress">
                <div class="user-text tw:pl-0">
                  <span class="tw:w-full"> {{ user.firstName }} {{ user.lastName }}</span>
                  <span class="tw:text-neutral-60 tw:w-full" title="{{ user.emailAddress }}">{{
                    user.emailAddress
                  }}</span>
                </div>
              </div>
            </li>
            <li class="divider"></li>
            <li>
              <a [href]="environment.accountSettingsUrl" i18n>My information</a>
              @if (!environment.production) {
                <a (click)="changeLanguage()" i18n> Change language </a>
              }
              <a (click)="goToAbout()" i18n>About</a>
            </li>
            <li class="divider divider-strong"></li>
            <li class="context-footer company-selection-footer">
              <a
                class="tw:flex tw:items-center"
                role="button"
                [href]="environment.signinUrl + '?msgCode=LOGOUT'"
                (click)="logout()"
              >
                <ga-icon class="tw:pr-2" [icon]="icons.Power" />
                <span i18n>Logout</span>
              </a>
            </li>
            <li class="tw:cursor-default tw:text-center">
              <span class="tw:text-neutral-60 tw:w-full">{{ version }}</span>
              <span class="tw:text-neutral-60 tw:w-full">{{ lastModified | date: 'medium' }}</span>
            </li>
          </ul>
        </li>
      }
    }
  </di-navbar-right-menu>
</di-navbar>
<di-gaia-assistant #gaiaAssistantChat />
<ng-template #functionDisabledTooltip>
  <span i18n>Sorry, this function is temporarily disabled. Please try again later.</span>
</ng-template>
